import axios from "axios";
import { derived, writable } from "svelte/store";

const {subscribe, set} = writable(null);

function init(locale: string): void {
  axios({
    baseURL: `${import.meta.env.VITE_CMS_ENDPOINT}`,
    url: `/auping/questionnaire/i18n/${locale}.json`,
  })
    .then((response) => {
      set(response.data);
    })
    .catch((e) => {
      console.error(`Trying to set a locale which is unavailable: '${locale}'`);
    });
}

function translate(translations, key, vars) {
  if (!translations) return;
  if (!key) throw new Error("no key provided to $t()");

  let text = translations[key];

  if (!text) {
    console.error(`no translation found for ${key}`);
    return key;
  }

  // Replace any passed in variables in the translation string.
  Object.keys(vars).map((k) => {
    const regex = new RegExp(`{{${k}}}`, "g");
    text = text.replace(regex, vars[k]);
  });

  return text;
}

export const translations = {
  subscribe,
  init,
};

export const t = derived(
  translations,
  ($translations) =>
    (key, vars = {}) =>
      translate($translations, key, vars)
);

export const translationExists = derived(
  translations,
  ($translations) => (key) => $translations ? !!$translations[key] : false
);
